import {createApp} from 'vue'
import CreateFolderOverlay from './CreateFolderOverlay'

const el = '.kb-component--create-folder-overlay'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CreateFolderOverlayDOM)=>{
            const props = {
                groupId: CreateFolderOverlay.dataset.groupId ?? "",
                content: CreateFolderOverlay.dataset.content ? JSON.parse(CreateFolderOverlay.dataset.content) : null,
            }
            const component = createApp(CreateFolderOverlay, props).use(Store)
            component.mount(CreateFolderOverlayDOM)
        })
    }
}